import { setOnline } from "../redux/slices/networkSlice";

export function initNetworkMonitor(store) {
  if (typeof window === "undefined") return () => {};

  const apply = () => {
    store.dispatch(setOnline(navigator.onLine));
  };

  window.addEventListener("online", apply);
  window.addEventListener("offline", apply);
  apply();

  return () => {
    window.removeEventListener("online", apply);
    window.removeEventListener("offline", apply);
  };
}
